<template>
  <ca-modal
    ref="modal"
    size="small"
    title="Cadastrar nova função">
    <template slot="body">
      <job-descriptions-form-page
        :is-valid.sync="isFormValid"
        :object.sync="jobDescription"
        :is-modal="true"></job-descriptions-form-page>
    </template>

    <ca-row slot="footer">
      <ca-col size="3">
        <ca-button full-width @click="$refs.modal.close()">
          Cancelar
        </ca-button>
      </ca-col>
      <ca-col offset="6" size="3">
        <ca-request-button
          :disabled="!isFormValid"
          :on-request="onSubmit"
          :on-request-success="onSubmitSuccess"
          :on-request-error="onSubmitError"
          theme="primary">
          Confirmar
        </ca-request-button>
      </ca-col>
    </ca-row>
  </ca-modal>
</template>

<script>
import JobDescriptionsFormPage from 'accountant/employer/job-descriptions/JobDescriptionsFormPage';
import { createNewJobDescription } from 'accountant/employer/job-descriptions/jobDescriptionService';

export default {
  name: 'CreateJobDescriptionModal',
  components: {
    JobDescriptionsFormPage,
  },
  data() {
    return {
      jobDescription: {},
      isFormValid: null,
    };
  },
  methods: {
    onSubmit() {
      return createNewJobDescription(this.jobDescription);
    },
    onSubmitSuccess() {
      this.$emit('created');
      this.$refs.modal.close();
      this.$toaster.success('Função criada com sucesso!');
    },
    onSubmitError() {
      this.$toaster.error('Aconteceu um erro, por favor tente novamente.');
    },
  },
};
</script>

<style scoped>
div ::v-deep .ca-heading--title {
  display: none;
}

div ::v-deep .ca-page-default {
  border: none;
  padding: unset;
}

div ::v-deep .ca-footer {
  display: none;
}
</style>
